<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase>
  <div id="mainBody" class="showcase-body" ngForm #mainBody="ngForm">
    <br/>
    <table id="tableDriverInfo" #tableDriverInfo class="bordered-table" style="width: 70%;">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetDriverInfo(urlDriverID)" title="Undo">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="OpenReport()" title="Report">
                  <i class="fa fa-sticky-note"></i>
                </button>
              </td>
              <td style="text-align: center;">Driver Information</td>
              <td style="text-align: -webkit-right; width:160px;">
                <span style="font-size:0.7em;color: darkred">Last Updated: {{driver?.lastUpdatedDate}}</span>
              </td>
              <td style="text-align: -webkit-right; width:50px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ReloadFromLDAP(urlDriverID)">
                  <i class="fa fa-cloud-download"></i>
                </button>
              </td>
            </tr>
          </table>
        </th>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined || urlDriverID==0">
        <td>
          <label>Status:</label>
        </td>
        <td (click)="changeDriverStatus(driver?.status_id, $event)" style="cursor: pointer">
          <div *ngIf="driver?.status_id==1">
                        <span class="fa fa-check" style="color:green;">
                            <label>&nbsp;Active</label>
                        </span>
          </div>
          <div *ngIf="driver?.status_id==2">
                        <span class="fa fa-close" style="color:rgb(0, 0, 202);">
                            <label>&nbsp;Inactive</label>
                        </span>
          </div>
          <div *ngIf="driver?.status_id==3">
                        <span class="fa fa-ban" style="color:rgb(202, 0, 0);">
                            <label>&nbsp;Suspended</label>
                        </span>
          </div>
        </td>
        <td>
          <label for="email">Email:</label>
        </td>
        <td>
          <input id="email" name="email" type="text" [ngModel]="driver?.email" (ngModelChange)="driver.email=$event" Class="modelo-text-input"
                 #email="ngModel" required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$" />
          <small *ngIf="email.errors && email.errors.required" class="validationError">Required</small>
          <small *ngIf="email.errors && email.errors.pattern" class="validationError">Invalid Email Address</small>
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="identification_id">GMIN:</label>
        </td>
        <td>
          <input id="identification_id" name="identification_id" type="text" [ngModel]="driver?.identificationId" (ngModelChange)="driver.identificationId=$event"
                 #identification_id="ngModel" class="modelo-text-input"  />
        </td>
        <td>
          <label for="department">Department:</label>
        </td>
        <td>
          <input name="department" id="department" type="text" [ngModel]="driver?.department" (ngModelChange)="driver.department=$event"
                 class="modelo-text-input">
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="firstName">First Name:</label>
        </td>
        <td>
          <input id="firstName" name="firstName" type="text" [ngModel]="driver?.firstName" (ngModelChange)="driver.firstName=$event"
                 class="modelo-text-input" #firstName="ngModel" required>
          <small *ngIf="firstName.errors && firstName.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <label for="employee_type_id">Employee Type:</label>
        </td>
        <td>
          <select name="employee_type_id" id="employee_type_id" [ngModel]="driver?.employeeTypeId" (ngModelChange)="driver.employeeTypeId=$event"
                  #employee_type_id="ngModel" required>
            <option *ngFor="let emptype of employeeTypes" value="{{emptype.employeeTypeId}}">
              {{emptype.employeeTypeName}}
            </option>
          </select>
          <small *ngIf="employee_type_id.errors && employee_type_id.errors.required" class="validationError">Required</small>
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="middleName">Middle:</label>
        </td>
        <td>
          <input name="middleName" id="middleName" type="text" [ngModel]="driver?.middleName" (ngModelChange)="driver.middleName=$event"
                 class="modelo-text-input">
        </td>
        <td>
          <label for="company">{{'Label-Company' | translate}}:</label>
        </td>
        <td>
          <input name="company" id="company" type="text" [ngModel]="driver?.company" (ngModelChange)="driver.company=$event" class="modelo-text-input">
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="lastName">Last Name:</label>
        </td>
        <td>
          <input name="lastName" id="lastName" type="text" [ngModel]="driver?.lastName" (ngModelChange)="driver.lastName=$event" class="modelo-text-input"
                 #lastName="ngModel" required>
          <small *ngIf="lastName.errors && lastName.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <label for="badge_id">Badge ID:</label>
        </td>
        <td>
          <input name="badge_id" id="badge_id" type="text" [ngModel]="driver?.badgeID" (ngModelChange)="driver.badgeID" class="modelo-text-input">
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="preferredName">Preferred Name:</label>
        </td>
        <td>
          <input name="preferredName" id="preferredName" type="text" [ngModel]="driver?.preferredName" (ngModelChange)="driver.preferredName=$event"
                 class="modelo-text-input">
        </td>
        <td>
          <label for="ratingScore">Rating Score:</label>
        </td>
        <td>
          <input name="ratingScore" id="ratingScore" type="number" [ngModel]="driver?.ratingScore" (ngModelChange)="driver.ratingScore=$event"
                 class="modelo-text-input">
        </td>
      </tr>
      <tr *ngIf="driver?.identificationId!=undefined|| urlDriverID==0">
        <td>
          <label for="driverComment">Comment:</label>
        </td>
        <td colspan="3">
          <input name="driverComment" id="driverComment" type="text" [ngModel]="driver?.comment" (ngModelChange)="driver.comment=$event"
                 class="modelo-text-input">
        </td>
      </tr>
    </table>

    <table id="tableTraining" #tableTraining class="bordered-table" *ngIf="driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddTraining(tableTraining)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetTraining(tableTraining)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Training / PreReq</td>
            </tr>
          </table>

        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td>
          <label>Training Course Name:</label>
        </td>
        <td>
          <label>Training Description:</label>
        </td>
        <td>
          <label>Date Completed:</label>
        </td>
        <td>
          <label>Site:</label>
        </td>
        <td>
          <label>Expiration Date:</label>
        </td>
        <td>
          <label>Attachment:</label>
        </td>
      </tr>


      <tr *ngFor="let item of driverTraining;let index = index;trackBy:trackByIndex;">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteTraining(item.driverTrainingId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <select style="font-family: Consolas;width:200px" name="training_course_name_{{index}}" id="{{'training_course_name_'+ index}}"
                  [(ngModel)]="item.trainingCourseId" (change)="updateCourseDescription($event);" #training_course_name_="ngModel"
                  required>
            <option *ngFor="let course of courses" value="{{course.trainingCourseId}}">
              {{course.courseNumberAndName}}
            </option>
          </select>
          <input style="display:none" name="{{'_training_course_name_'+ index}}" id="{{'_training_course_name_'+ index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.courseNumber">
          <small *ngIf="training_course_name_.errors && training_course_name_.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <span id="{{'training_description_' +index}}" class="modelo-text-input">{{item.courseName}}</span>
        </td>
        <td>
          <gm-datepicker name="{{'training_dateInput'+index}}" id="{{'training_dateInput'+index}}" [ngModel]="(item.completeDate!=null)? (item.completeDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.completeDate=$event" [minDate]="" #training_dateInput="ngModel" required></gm-datepicker>
          <input style="display:none" name="{{'_training_dateInput'+index}}" id="{{'_training_dateInput'+index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.completeDate | date:'yyyy-MM-dd':'UTC'">
          <small *ngIf="training_dateInput.errors && training_dateInput.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select id="{{'traning_site_'+index}}" name="{{'traning_site_'+index}}" (focus)="setOriginalSiteId(item.siteId)" (change)="changeSite($event,item,index)"
                  [(ngModel)]="item.siteId" #training_site_="ngModel" required>
            <option *ngFor="let si of trainingsites" value={{si.siteId}}>
              {{si.siteName}}
            </option>
          </select>
          <input style="display:none" name="{{'_training_site_'+ index}}" id="{{'_training_site_'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.siteName">
          <small *ngIf="training_site_.errors && training_site_.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'dtraining_expiration_date'+index}}" id="{{'dtraining_expiration_date'+index}}" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.expirationDate=$event" [minDate]="" [defaultDate]="item.expirationDate"></gm-datepicker>
          <input style="display:none" name="{{'_dtraining_expiration_date'+index}}" id="{{'_dtraining_expiration_date'+index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.expirationDate | date:'yyyy-MM-dd':'UTC'">
        </td>
        <td>
          <button *ngIf="item.driverTrainingId" id="{{'drtraining_attachment_upload'+index}}" class="btn btn-xs btn-secondary btn-group"
                  (click)="OpenModal('',index,true,'drivertrainings', item.driverTrainingId)">
            <i class="fa fa-upload"></i>
          </button>
          <button *ngIf="item.driverTrainingId && item.attachment" id="{{'drtraining_attachment_download'+index}}" [ngClass]="{'btn btn-xs btn-secondary btn-group':item.attachment==undefined,'btn btn-xs btn-primary btn-group':item.attachment!==undefined}"
                  (click)="downloadAttachmentFile(item.attachment)">
            <i class="fa fa-download"></i>
          </button>
        </td>

      </tr>
    </table>
    <table #tableLevel id="tableLevel" class="bordered-table" *ngIf="driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1%;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddLevel(tableTraining)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="Resetlevel(tableLevel)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Level</td>
            </tr>
          </table>
        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td>
          <label>Driver Level:</label>
        </td>
        <td>
          <label>Date Obtained:</label>
        </td>
        <td>
          <label>Site Provided:</label>
        </td>
        <td>
          <label>Expiration Date:</label>
        </td>
        <td>
          <label>Attachment:</label>
        </td>
        <td>
          <label>Campus Driving Permit #:</label>
        </td>
        <td>
          <label>Proving Ground License #:</label>
        </td>
      </tr>
      <tr *ngFor="let item of driverDrivingLevel; let index=index;trackBy:trackByIndex;">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteLevel(item.driverDrivingLevelId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <select style="font-family: Consolas;width:160px" name="driver_level_{{index}}" id="{{'driver_level'+ index}}" [(ngModel)]="item.drivingLevelId"
                  (change)="updateDriverLevelName($event);" #driver_level="ngModel" required>
            <option *ngFor="let level of drivingLevels" value="{{level.drivingLevelId}}">
              {{level.levelNameAndDesc}}
            </option>
          </select>
          <input style="display:none" name="{{'driver_level_description'+ index}}" id="{{'driver_level_description'+ index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.drivingLevelName">
          <small *ngIf="driver_level.errors && driver_level.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'level_date_obtained'+index}}" id="{{'level_date_obtained'+index}}" [ngModel]="(item.trainingDate!=null)? (item.trainingDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.trainingDate=$event" [minDate]="" #level_date_obtained="ngModel" required></gm-datepicker>
          <input style="display:none" name="{{'_level_date_obtained'+index}}" id="{{'_level_date_obtained'+index}}" type="text" class="modelo-text-input"
                 [ngModel]="(item.trainingDate!=null)? (item.trainingDate | date:'yyyy-MM-dd':'UTC'):null">
          <small *ngIf="level_date_obtained.errors && level_date_obtained.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'level_site_provided'+index}}" id="{{'level_site_provided'+index}}" (focus)="setOriginalSiteId(item.siteId)"
                  (change)="changeSite($event,item,index)" [(ngModel)]="item.siteId" #level_site_provided="ngModel" required>
            <option *ngFor="let si of levelsites" value={{si.siteId}}>
              {{si.siteName}}
            </option>
          </select>
          <input style="display:none" name="{{'level_site_'+ index}}" id="{{'level_site_'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.siteName">
          <small *ngIf="level_site_provided.errors && level_site_provided.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'level_expiration_date'+index}}" id="{{'level_expiration_date'+index}}" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.expirationDate=$event" [minDate]="" #level_expiration_date="ngModel"></gm-datepicker>
          <input style="display:none" name="{{'_level_expiration_date'+index}}" id="{{'_level_expiration_date'+index}}" type="text"
                 class="modelo-text-input" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null">
        </td>
        <td>
          <button *ngIf="item.driverDrivingLevelId" id="{{'level_attachment_upload'+index}}" class="btn btn-xs btn-secondary btn-group"
                  (click)="OpenModal('',index,true,'driverlevels', item.driverDrivingLevelId)">
            <i class="fa fa-upload"></i>
          </button>
          <button *ngIf="item.driverDrivingLevelId && item.attachment" id="{{'level_attachment_download'+index}}" [ngClass]="{'btn btn-xs btn-secondary btn-group':item.attachment==undefined,'btn btn-xs btn-primary btn-group':item.attachment!==undefined}"
                  (click)="downloadAttachmentFile(item.attachment)">
            <i class="fa fa-download"></i>
          </button>
        </td>
        <td>
          <input name="{{'campus_driving_permit_number'+index}}" id="{{'campus_driving_permit_number'+index}}" type="text" [(ngModel)]="item.campusDrivingPermitNumber"
                 class="modelo-text-input">
        </td>
        <td>
          <input name="{{'proving_ground_license_number'+index}}" id="{{'proving_ground_license_number'+index}}" type="text" [(ngModel)]="item.provingGroundLicenseNumber"
                 class="modelo-text-input">
        </td>
      </tr>
    </table>

    <table #tableEndorsement id="tableEndorsement" class="bordered-table" *ngIf="driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddEndorsement(tableEndorsement)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetEndorsement(tableEndorsement)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <!--<td class="trainingLoading" style="width:1px; color: darkred; display:none;">Loading...</td>-->
              <td style="text-align: center">Endorsement</td>
            </tr>
          </table>

        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td>
          <label>Endorsement:</label>
        </td>
        <td>
          <label>Endorsement Description:</label>
        </td>
        <td>
          <label>Date Obtained:</label>
        </td>
        <td>
          <label>Site Provided:</label>
        </td>
        <td>
          <label>Expiration Date:</label>
        </td>
        <td>
          <label>Attachment</label>
        </td>
      </tr>
      <tr *ngFor="let item of driverEndorsement; let index = index;trackBy:trackByIndex">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteEndorsement(item.driverEndorsementId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <select style="font-family: Consolas;width:160px" name="{{'endorsement'+index}}" id="{{'endorsement'+index}}" [(ngModel)]="item.endorsementId"
                  (change)="updateEndorsementDescription($event);" #endorsement="ngModel" required>
            <option *ngFor="let endor of endorsements" value="{{endor.endorsementId}}">
              {{endor.endorsementNameAndDesc}}
            </option>
          </select>
          <input style="display:none" name="{{'_endorsement'+ index}}" id="{{'_endorsement'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.endorsementName">
          <small *ngIf="endorsement.errors && endorsement.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <span id="{{'endorsement_description' +index}}" class="modelo-text-input">{{item.endorsementDesc}}</span>
        </td>
        <td>
          <gm-datepicker name="{{'endorsement_date_obtained'+index}}" id="{{'endorsement_date_obtained'+index}}" [ngModel]="(item.dateValidated!=null)? (item.dateValidated | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.dateValidated=$event" [minDate]="" #endorsement_date_obtained="ngModel" required></gm-datepicker>
          <input style="display:none" name="{{'_endorsement_date_obtained'+index}}" id="{{'_endorsement_date_obtained'+index}}" type="text"
                 class="modelo-text-input" [ngModel]="(item.dateValidated!=null)? (item.dateValidated | date:'yyyy-MM-dd':'UTC'):null">
          <small *ngIf="endorsement_date_obtained.errors && endorsement_date_obtained.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'endorsement_site_provided'+index}}" (focus)="setOriginalSiteId(item.siteId)" (change)="changeSite($event,item,index)"
                  [(ngModel)]="item.siteId" #endorsement_site_provided="ngModel" required>
            <option *ngFor="let si of endorsementsites" value={{si.siteId}}>
              {{si.siteName}}
            </option>
          </select>
          <input style="display:none" name="{{'endorsement_site_'+ index}}" id="{{'endorsement_site_'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.siteName">
          <small *ngIf="endorsement_site_provided.errors && endorsement_site_provided.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'endorsement_expiration_date'+index}}" id="{{'endorsement_expiration_date'+index}}" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.expirationDate=$event" [minDate]=""></gm-datepicker>
          <input style="display:none" name="{{'_endorsement_expiration_date'+index}}" id="{{'_endorsement_expiration_date'+index}}"
                 type="text" class="modelo-text-input" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null">
        </td>
        <td>
          <button *ngIf="item.driverEndorsementId" id="{{'endorsement_attachment_upload'+index}}" class="btn btn-xs btn-secondary btn-group"
                  (click)="OpenModal('',index,true,'driverendorsements', item.driverEndorsementId)">
            <i class="fa fa-upload"></i>
          </button>
          <button *ngIf="item.driverEndorsementId && item.attachment" id="{{'endorsement_attachment_download'+index}}" [ngClass]="{'btn btn-xs btn-secondary btn-group':item.attachment==undefined,'btn btn-xs btn-primary btn-group':item.attachment!==undefined}"
                  (click)="downloadAttachmentFile(item.attachment)">
            <i class="fa fa-download"></i>
          </button>
        </td>
      </tr>
    </table>

    <table #tableGovLicense id="tableGovLicense" class="bordered-table" *ngIf="driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="addGovernmentEndorsement(tableGovLicense)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="resetGovernmentEndorsement(tableGovLicense)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Government Endorsement</td>
            </tr>
          </table>
        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td>
          <label>Region</label>
        </td>
        <td>
          <label>License Type</label>
        </td>
        <td>
          <label>Endorsement</label>
        </td>
        <td>
          <label>Date Validated/Inspected</label>
        </td>
        <td>
          <label>License Expiration Date</label>
        </td>
      </tr>
      <tr *ngFor="let item of driverGovernmentEndorsements; let index = index; trackBy:trackByIndex">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteGovernmentEndorsement(item.driverGovernmentEndorsementId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <select name="{{'gov_endorsement_region'+index}}" [(ngModel)]="item.regionId" #gov_endorsement_region="ngModel" required>
            <option *ngFor="let region of regions" value={{region.regionId}}>
              {{region.regionName}}
            </option>
          </select>
          <input style="display:none" name="{{'_gov_endorsement_region'+ index}}" id="{{'_gov_endorsement_region'+ index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.regionName">
          <small *ngIf="gov_endorsement_region.errors && gov_endorsement_region.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'gov_endorsement_license_type'+index}}" id="{{'gov_endorsement_license_type'+index}}" [(ngModel)]="item.licenseTypeId"
                  #gov_endorsement_license_type="ngModel" required>
            <option *ngFor="let licenseType of licenseTypes" value="{{licenseType.licenseTypeId}}">
              {{licenseType.licenseType}}
            </option>
          </select>
          <input style="display:none" name="{{'_gov_endorsement_license_type'+ index}}" id="{{'_gov_endorsement_license_type'+ index}}"
                 type="text" class="modelo-text-input" [ngModel]="item.licenseType">
          <small *ngIf="gov_endorsement_license_type.errors && gov_endorsement_license_type.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'governmentEndorsement'+index}}" id="{{'governmentEndorsement'+index}}" [(ngModel)]="item.governmentEndorsementId"
                  #governmentEndorsement="ngModel" required>
            <option *ngFor="let govEndorsement of govEndorsements" value="{{govEndorsement.governmentEndorsementId}}">
              {{govEndorsement.endorsementName}}
            </option>
          </select>
          <input style="display:none" name="{{'_governmentEndorsement'+ index}}" id="{{'_governmentEndorsement'+ index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.endorsementName">
          <small *ngIf="governmentEndorsement.errors && governmentEndorsement.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'gov_validation_date'+index}}" id="{{'gov_validation_date'+index}}" [ngModel]="(item.dateValidated != null)? (item.dateValidated | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.dateValidated=$event" [minDate]="" #gov_validation_date="ngModel" required>
          </gm-datepicker>
          <input style="display:none" name="{{'_gov_validation_date'+index}}" id="{{'_gov_validation_date'+index}}" type="text" class="modelo-text-input"
                 [ngModel]="(item.dateValidated != null)? (item.dateValidated | date:'yyyy-MM-dd':'UTC'):null" />
          <small *ngIf="gov_validation_date.errors && gov_validation_date.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <gm-datepicker name="{{'gov_endorsement_expiration_date'+index}}" id="{{'gov_endorsement_expiration_date'+index}}" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.expirationDate=$event" [minDate]="" #gov_endorsement_expiration_date="ngModel"
                         required>
          </gm-datepicker>
          <input style="display:none" name="{{'_gov_endorsement_expiration_date'+index}}" id="{{'_gov_endorsement_expiration_date'+index}}"
                 type="text" class="modelo-text-input" [ngModel]="(item.expirationDate!=null)? (item.expirationDate | date:'yyyy-MM-dd':'UTC'):null"
          />
          <small *ngIf="gov_endorsement_expiration_date.errors && gov_endorsement_expiration_date.errors.required" class="validationError">Required</small>
        </td>
      </tr>
    </table>

    <table #tableViolation id="tableViolation" class="bordered-table" *ngIf="isEditable && driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddViolation(tableViolation)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetViolation(tableViolation)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Violation
                <span style="font-size: 0.7em; color:darkred; margin-left:20px;">(Total Pts: {{totalViolationPoints}})</span>
              </td>
            </tr>
          </table>

        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td style="width:130px;">
          <label>Date</label>
        </td>
        <td style="width:80px;">
          <label>Time</label>
        </td>
        <td style="width:90px;">
          <label>Classification</label>
        </td>
        <td style="width:200px;">
          <label>Type</label>
        </td>
        <td style="width:120px;">
          <label>Desc/Code</label>
        </td>
        <td style="width:50px;">
          <label>Pts</label>
        </td>
        <td style="width:80px;">
          <label>Site</label>
        </td>
        <td style="width:90px;">
          <label>Location Cat.</label>
        </td>
        <td style="width:170px">
          <label>Location Area</label>
        </td>
        <td>
          <label>Sub. Location</label>
        </td>
        <td style="width:130px;">
          <label>Expiration Date</label>
        </td>
        <td style="width:75px;">
          <label>Comment</label>
        </td>
        <td style="width:75px;">
          <label>Attachment</label>
        </td>
      </tr>
      <tr *ngFor="let item of driverViolation; let index = index; trackBy:trackByIndex">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteViolation(item.violationId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <gm-datepicker name="{{'violation_date'+index}}" id="{{'violation_date'+index}}" [ngModel]="(item.violationDate!=null)? (item.violationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.violationDate=$event" [minDate]="" #violation_date="ngModel" required></gm-datepicker>
          <input style="display:none" name="{{'_violation_date'+index}}" id="{{'_violation_date'+index}}" type="text" class="modelo-text-input"
                 [ngModel]="(item.violationDate!=null)? (item.violationDate | date:'yyyy-MM-dd':'UTC'):null">
          <small *ngIf="violation_date.errors && violation_date.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <input name="{{'violation_time'+index}}" id="{{'violation_time'+index}}" type="text" class="modelo-text-input" [(ngModel)]="item.fakeViolationTime"
                 #violation_time="ngModel" pattern="([01]?[0-9]|2[0-3]):[0-5][0-9]" required>
          <small *ngIf="violation_time.errors && violation_time.errors.required" class="validationError">Required</small>
          <small *ngIf="violation_time.errors && violation_time.errors.pattern" class="validationError">Invalid Time format HH:mm)</small>
        </td>
        <td>
          <select style="font-family: Consolas;width:90px;overflow:hidden" name="{{'violation_definition'+ index}}" id="{{'violation_definition'+ index}}" [(ngModel)]="item.violationDefinitionId"
                  (change)="updateViolationDefinition($event,index);" title="{{item.classification}} | {{item.points}} | {{item.type}} | {{item.description}}"
                  #violation_definition="ngModel" required>
            <option [ngStyle]="{'color':vi.points<=3? '#5DDE03':vi.points<=6?'#CBB617':vi.points<=9?'#CB3517':'#900C3F'}" *ngFor="let vi of violationDefinitions"
                    value={{vi.violationDefinitionId}}>
              {{vi.classificationAndDetail}}
            </option>
          </select>
          <input style="display:none" name="{{'_violation_definition_'+ index}}" id="{{'_violation_definition_'+ index}}" type="text"
                 class="modelo-text-input" value="{{item.classification}} |  {{item.points}}">
          <small *ngIf="violation_definition.errors && violation_definition.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <span id="{{'violation_definition_type' +index}}" class="modelo-text-input">{{item.type}}</span>
        </td>
        <td>
          <span id="{{'violation_definition_desc' +index}}" class="modelo-text-input" title="{{item.description}}">{{item.description.substr(0,15)}}...</span>
        </td>
        <td>
          <input name="{{'violation_definition_point'+index}}" id="{{'violation_definition_point'+index}}" type="text" class="modelo-text-input"
                 (change)="ChangeViolationPoints()" [(ngModel)]="item.violationPoints" #violation_definition_point="ngModel"
                 required pattern="^\d{1,2}$" />
          <small *ngIf="violation_definition_point.errors && violation_definition_point.errors.required" class="validationError">Required</small>
          <small *ngIf="violation_definition_point.errors && violation_definition_point.errors.pattern" class="validationError">Invalid Points (numbers only)</small>
        </td>
        <td>
          <select style="font-family: Consolas;width:80px" name="{{'violation_site'+index}}" id="{{'violation_site'+index}}" [(ngModel)]="item.siteId" (focus)="setOriginalSiteId(item.siteId)"
                  (change)="changeSite($event,item,index)" #violation_site="ngModel" required>
            <option *ngFor="let si of violationsites" value={{si.siteId}}>
              {{si.siteCodeAndName}}
            </option>
          </select>
          <input style="display:none" name="{{'_violation_site_'+ index}}" id="{{'_violation_site_'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.siteCodeAndName">
          <small *ngIf="violation_site.errors && violation_site.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'violation_location_type'+index}}" id="{{'violation_location_type'+index}}" [(ngModel)]="item.locationTypeId"
                  style="width:100px" (change)="changeLocationType($event,item.locationTypeId,index)" #violation_location_type="ngModel"
                  required>
            <option *ngFor="let lo of locationTypes" value={{lo.locationTypeId}}>
              {{lo.locationType}}
            </option>
          </select>
          <input style="display:none" name="{{'_violation_location_type'+ index}}" id="{{'_violation_location_type'+ index}}" type="text"
                 class="modelo-text-input" [ngModel]="item.locationName">
          <small *ngIf="violation_location_type.errors && violation_location_type.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <select name="{{'violation_location'+index}}" id="{{'violation_location'+index}}" style="width:200px" [(ngModel)]="item.locationId"
                  #violation_location="ngModel" required>
            <option *ngFor="let lo of MasterViolationLocations[index]" value={{lo.locationId}}>
              {{lo.locationName}}
            </option>
          </select>
          <input style="display:none" name="{{'_violation_location'+ index}}" id="{{'_violation_location'+ index}}" type="text" class="modelo-text-input"
                 [ngModel]="item.locationName">
          <small *ngIf="violation_location.errors && violation_location.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <input name="{{'violation_area'+index}}" id="{{'violation_area'+index}}" type="text" class="modelo-text-input" [(ngModel)]="item.violationArea"
                 #violation_area="ngModel" maxlength="50" />
        </td>
        <td>
          <gm-datepicker name="{{'points_expiration_date'+index}}" id="{{'points_expiration_date'+index}}" [ngModel]="(item.pointsExpirationDate!=null)? (item.pointsExpirationDate | date:'yyyy-MM-dd':'UTC'):null"
                         (ngModelChange)="item.pointsExpirationDate=$event" [minDate]="" #points_expiration_date="ngModel" required></gm-datepicker>
          <input style="display:none" name="{{'_points_expiration_date'+index}}" id="{{'_points_expiration_date'+index}}" type="text" class="modelo-text-input"
                 [ngModel]="(item.pointsExpirationDate!=null)? (item.pointsExpirationDate | date:'yyyy-MM-dd':'UTC'):null">
          <small *ngIf="points_expiration_date.errors && points_expiration_date.errors.required" class="validationError">Required</small>
        </td>
        <td>
          <button id="{{'violation_comment'+index}}" [ngClass]="(item.violationComment==undefined || (item.violationComment.length==0 && item.commentBeChanged==undefined)) ?'btn btn-xs btn-secondary btn-group':(item.commentBeChanged==undefined)?'btn btn-xs btn-primary btn-group':'btn btn-xs btn-hasContent btn-group'"
                  (click)="OpenModal(item.violationComment, index)" title="{{item.violationComment}}">
            <i class="fa fa-comment"></i>
          </button>
        </td>
        <td>
          <button *ngIf="item.violationId" id="{{'violation_attachment_upload'+index}}" class="btn btn-xs btn-secondary btn-group"
                  (click)="OpenModal('',index,true,'violations', item.violationId)">
            <i class="fa fa-upload"></i>
          </button>
          <button *ngIf="item.violationId && item.attachment" id="{{'violation_attachment_download'+index}}" [ngClass]="{'btn btn-xs btn-secondary btn-group':item.attachment==undefined,'btn btn-xs btn-primary btn-group':item.attachment!==undefined}"
                  (click)="downloadAttachmentFile(item.attachment)">
            <i class="fa fa-download"></i>
          </button>
        </td>
      </tr>
    </table>
    <table #tableAccident id="tableAccident" class="bordered-table" *ngIf="isEditable && driver?.driverID!=undefined && driver?.driverID!=0">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="AddAccident(tableAccident)">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
              <td style="width:1px;">
                <button class="btn btn-xs btn-secondary btn-group" (click)="ResetAccident(tableAccident)">
                  <i class="fa fa-undo"></i>
                </button>
              </td>
              <td style="text-align: center">Accidents</td>
            </tr>
          </table>

        </th>
      </tr>
      <tr>
        <td *ngIf="isSuperAdmin"></td>
        <td>
          <label>Accident Date & Time</label>
        </td>
        <td>
          <label>Classification</label>
        </td>
        <td>
          <label>Causation</label>
        </td>
        <td>
          <label>Site</label>
        </td>
        <td>
          <label>Location Type</label>
        </td>
        <td>
          <label>Location</label>
        </td>
        <td>
          <label>Attachment</label>
        </td>
        <td>
          <label>Action</label>
        </td>
      </tr>
      <tr *ngFor="let item of accidents; let index = index; trackBy:trackByIndex">
        <td *ngIf="isSuperAdmin">
          <button class="btn btn-xs btn-primary" (click)="deleteAccident(item.accidentId, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
        <td>
          <span id="{{'accident_date'+index}}">{{item.accidentDate}} {{item.accidentTime}}</span>
        </td>
        <td>
          <span>{{item.classification}}</span>
        </td>
        <td>
          <span>{{item.causation}}</span>
        </td>
        <td>
          <span>{{item.siteName}}</span>
        </td>
        <td>
          <span>{{item.locationTypeName}}</span>
        </td>
        <td>
          <span>{{item.locationName}}</span>
        </td>
        <td>
          <button *ngIf="item.accidentId" id="{{'accident_attachment_upload'+index}}" class="btn btn-xs btn-secondary btn-group" (click)="OpenModal('',index,true,'accidents', item.accidentId)">
            <i class="fa fa-upload"></i>
          </button>
          <button *ngIf="item.accidentId && item.attachment" id="{{'accident_attachment_download'+index}}" [ngClass]="{'btn btn-xs btn-secondary btn-group':item.attachment==undefined,'btn btn-xs btn-primary btn-group':item.attachment!==undefined}"
                  (click)="downloadAttachmentFile(item.attachment)">
            <i class="fa fa-download"></i>
          </button>
        </td>
        <td>
          <button class="btn btn-xs btn-secondary btn-group" (click)="redirectToAccidents(item.accidentId, driver.personID)">
            <i class="fa fa-edit"></i>
          </button>
        </td>
      </tr>
    </table>
    <br/>
    <div class="modal fade" id="ViolationModal" tabindex="-1" role="dialog" aria-labelledby="ViolationModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="min-width: 650px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseModal()">&times;
            </button>
            <input type="text" id="hiddenCommentIndex" index="-1" style="display:none;" />
          </div>
          <div>
            <table>
              <tr>
                <th *ngIf="!this.modalForAttachment">
                  <span style="margin-left: 30px;">Comment</span>
                </th>
                <th *ngIf="this.modalForAttachment">
                  <span style="margin-left: 30px;">Pick a file to upload</span>
                </th>
              </tr>
              <tr>
                <td>
                                    <textarea *ngIf="!this.modalForAttachment" style="margin-left: 30px;" name="Comment" id="Comment" [ngModel]="violationComment"
                                              (ngModelChange)="violationComment=$event" class="modelo-text-input" cols="70" rows="10"></textarea>
                  <input *ngIf="this.modalForAttachment" style="margin-left: 30px;" type="file" id="myFile" (change)="handleFileInput($event.target.files)">
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button *ngIf="!this.modalForAttachment" type="button" class="btn btn-secondary" data-dismiss="modal" (click)="CloseModal()">Close</button>
            <button *ngIf="!this.modalForAttachment" type="button" class="btn btn-primary" (click)="SaveComment()">Save changes</button>
            <span id="uploading" *ngIf="this.modalForAttachment" style="display:none;">Uploading <img src="../../assets/images/animated_loading__by__amiri.gif" width="70" height="50"/>Please Wait.</span>
            <button id="uploadFileBTN" *ngIf="this.modalForAttachment" type="button" class="btn btn-secondary" (click)="UploadFile()">Upload Attachment</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" [disabled]="!mainBody.valid" (click)="SaveDriver()">
    <i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange class="btn btn-primary-white btn-group" onclick="window.location.reload()">
    <i class="fa fa-refresh"></i>&nbsp;Reset</button>
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>
